import * as React from "react";
import {UserStoreState, UserStatus} from "../../store/UserStore";
import {DashboardUserService, DASHBOARD_USER_SERVICE_NAME} from "../../service/DashboardUserService";
import {LoadingSpinner} from "../util/LoadingSpinner";
import {kernel} from "../../ioc/IOCHelper";
import {Alert} from "../form/Alert";
import {uuid} from "../../utils/UUID";


interface State {
    username?: string;
    password?: string;
    status?: UserStatus;
    operatorId?: number;
    submitted?: boolean;
    loading?: boolean;
    operatorName?: string;
}


export class LoginForm extends React.Component<UserStoreState, State> {
    dashboardUserService: DashboardUserService;

    constructor(props: UserStoreState) {
        super(props);
        this.dashboardUserService = kernel.get<DashboardUserService>(DASHBOARD_USER_SERVICE_NAME);
        let operatorId, operatorName;
        if (this.dashboardUserService.hasSavedOperator()) {
            operatorId = this.dashboardUserService.getSavedOperatorId();
            operatorName = this.dashboardUserService.getSaveOperatorName();
        }
        this.state = {operatorId: operatorId, loading: false, operatorName: operatorName};
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.status != UserStatus.LOGGED_IN && prevProps.status != this.props.status) {
            let operatorId, operatorName;
            if (this.dashboardUserService.hasSavedOperator()) {
                operatorId = this.dashboardUserService.getSavedOperatorId();
                operatorName = this.dashboardUserService.getSaveOperatorName();
            }
            this.setState({operatorId: operatorId, loading: false, operatorName: operatorName});
        }
    }

    getOktaLogin() {
        if ("true" == oktaEnabled) {
            let oktaLoginUrl = oktaAuthUrl +
                '&client_id=' + oktaClientId +
                '&state=' + uuid() +
                '&redirect_uri=' + oktaRedirectUrl;
            return (<div>
                <a href={oktaLoginUrl} className="btn btn-success block full-width">Okta Login</a>
            </div>);
        } else {
            return <div/>;
        }

    }

    getLoginForm() {

        if (this.state.loading == true) {
            return <LoadingSpinner/>;
        }
        return (
            <div>
                {this.getOktaLogin()}
            </div>
        );
    }

    render() {
        if (this.props.status == UserStatus.LOGGED_IN) {
            return <div/>;
        }
        let styles = {
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            zIndex: 999999
        };

        return (
            <div style={styles}>
                <div className="middle-box text-center loginscreen animated fadeInDown">
                    <div>
                        <div className="login-logo"></div>
                        <h3 className="welcome">Welcome to Global Poker Dashboard</h3>
                        <div className="test-environment-alert">
                            <Alert type="info" text="Please note that this is a test/local environment"/>
                        </div>
                        {this.getLoginForm()}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/user/LoginForm.tsx